"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailProviders = void 0;
const credentials_1 = require("../credentials");
const provider_enum_1 = require("../provider.enum");
const types_1 = require("../../../types");
const ui_1 = require("../../../ui");
exports.emailProviders = [
    {
        id: provider_enum_1.EmailProviderIdEnum.Novu,
        displayName: 'Novu Email',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: [],
        docReference: `https://docs.novu.co/integrations/providers/default-providers${ui_1.UTM_CAMPAIGN_QUERY_PARAM}#novu-email-provider`,
        logoFileName: { light: 'novu.png', dark: 'novu.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Mailgun,
        displayName: 'Mailgun',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.mailgunConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/mailgun${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'mailgun.svg', dark: 'mailgun.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Mailjet,
        displayName: 'Mailjet',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.mailjetConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/mailjet${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'mailjet.png', dark: 'mailjet.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Mailtrap,
        displayName: 'Mailtrap',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.mailtrapConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/mailtrap${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'mailtrap.svg', dark: 'mailtrap.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Mandrill,
        displayName: 'Mandrill',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.mandrillConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/mandrill${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'mandrill.svg', dark: 'mandrill.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Postmark,
        displayName: 'Postmark',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.postmarkConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/postmark${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'postmark.png', dark: 'postmark.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.SendGrid,
        displayName: 'SendGrid',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.sendgridConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/sendgrid${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'sendgrid.png', dark: 'sendgrid.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Sendinblue,
        displayName: 'Sendinblue',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.sendinblueConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/sendinblue${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'sendinblue.png', dark: 'sendinblue.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.SES,
        displayName: 'SES',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.sesConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/amazon-ses${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'ses.svg', dark: 'ses.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.NetCore,
        displayName: 'Netcore',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.netCoreConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/netcore${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'netcore.png', dark: 'netcore.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.CustomSMTP,
        displayName: 'Custom SMTP',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.nodemailerConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/custom-smtp${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'custom_smtp.svg', dark: 'custom_smtp.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.MailerSend,
        displayName: 'MailerSend',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.mailerSendConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/mailersend${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'mailersend.svg', dark: 'mailersend.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Outlook365,
        displayName: 'Microsoft Outlook365',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.outlook365Config,
        docReference: `https://docs.novu.co/integrations/providers/email/outlook365${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'outlook365.png', dark: 'outlook365.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Infobip,
        displayName: 'Infobip',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.infobipEmailConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/infobip${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'infobip.png', dark: 'infobip.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Braze,
        displayName: 'Braze',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.brazeEmailConfig,
        docReference: 'https://www.braze.com/docs/api/endpoints/messaging/send_messages/post_send_messages/',
        logoFileName: { light: 'braze.svg', dark: 'braze.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Resend,
        displayName: 'Resend',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.resendConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/resend${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'resend.svg', dark: 'resend.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.Plunk,
        displayName: 'Plunk',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.plunkConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/plunk${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'plunk.png', dark: 'plunk.png' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.SparkPost,
        displayName: 'SparkPost',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.sparkpostConfig,
        docReference: `https://docs.novu.co/integrations/providers/email/sparkpost${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'sparkpost.svg', dark: 'sparkpost.svg' },
    },
    {
        id: provider_enum_1.EmailProviderIdEnum.EmailWebhook,
        displayName: 'Email Webhook',
        channel: types_1.ChannelTypeEnum.EMAIL,
        credentials: credentials_1.emailWebhookConfig,
        betaVersion: true,
        docReference: `https://docs.novu.co/channels/email/email-webhook${ui_1.UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'email_webhook.svg', dark: 'email_webhook.svg' },
    },
];
